import React from 'react';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import text from './text';

// icons import
import motorcycle from './icons/motorcycle.svg';
import car from './icons/car.svg';
import bus from './icons/bus.svg';
import truck from './icons/truck.svg';
import bicycle from './icons/bicycle.svg';
import scooter from './icons/scooter.svg';
import walker from './icons/walker.svg';

const language = window.location.hash === '#en' ? 'eng' : 'hun';

const VEHICLE_TYPES_REDUCED = {
    motorcycle: "motorcycle",
    car: "car",
    bus: "bus",
    truck: "truck",
    bicycle: "bicycle",
    scooter: "scooter",
    walker: "walker",
    other: "other"
  }

export default ({filter, onChange}) => {
  return (
    <div className="filterByVehicleType option">
      <FormControl component="fieldset">
      <FormLabel component="legend">{text[language].filtersGroupNames.vehicle}</FormLabel>
        <table>
            <tbody>
            <tr>
                <td>
                <FormControlLabel
                labelPlacement="top"
                label={
                    <img src={motorcycle} className="vehicle-icon" alt="motorcycle" />
                }
                control={
                    <Switch
                    checked={filter["motorcycle"]}
                    onChange={() => onChange(VEHICLE_TYPES_REDUCED.motorcycle)}
                    color="primary"
                    />
                }
                />
                </td>
                <td>
                <FormControlLabel
                labelPlacement="top"
                label={
                    <img src={car} className="vehicle-icon" alt="car" />
                }
                control={
                    <Switch
                    checked={filter["car"]}
                    onChange={() => onChange(VEHICLE_TYPES_REDUCED.car)}
                    color="primary"
                    />
                }
                />
                </td>
                <td>
                <FormControlLabel
                labelPlacement="top"
                label={
                    <img src={bus} className="vehicle-icon" alt="bus" />
                }
                control={
                    <Switch
                    checked={filter["bus"]}
                    onClick={() => onChange(VEHICLE_TYPES_REDUCED.bus)}
                    color="primary"
                    />
                }
                />
                </td>
                <td>
                <FormControlLabel
                labelPlacement="top"
                label={
                    <img src={truck} className="vehicle-icon" alt="truck" />
                }
                control={
                    <Switch
                    checked={filter["truck"]}
                    onClick={() => onChange(VEHICLE_TYPES_REDUCED.truck)}
                    color="primary"
                    />
                }
                />
                </td>
            </tr>    
            <tr>    
                <td>
                <FormControlLabel
                labelPlacement="top"
                label={
                    <img src={bicycle} className="vehicle-icon" alt="bicycle" />
                }
                control={
                    <Switch
                    checked={filter["bicycle"]}
                    onClick={() => onChange(VEHICLE_TYPES_REDUCED.bicycle)}
                    color="primary"
                    />
                }
                />
                </td>
                <td>
                <FormControlLabel
                labelPlacement="top"
                label={
                    <img src={scooter} className="vehicle-icon" alt="scooter" />
                }
                control={
                    <Switch
                    checked={filter["scooter"]}
                    onClick={() => onChange(VEHICLE_TYPES_REDUCED.scooter)}
                    color="primary"
                    />
                }
                />
                </td>
                <td>
                <FormControlLabel
                labelPlacement="top"
                label={
                    <img src={walker} className="vehicle-icon" alt="walker" />
                }
                control={
                    <Switch
                    checked={filter["walker"]}
                    onClick={() => onChange(VEHICLE_TYPES_REDUCED.walker)}
                    color="primary"
                    />
                }
                />
                </td>
                <td>
                <FormControlLabel
                labelPlacement="top"
                label={
                    text[language].vehicleToolTip[7]
                }
                control={
                    <Switch
                    checked={filter["other"]}
                    onClick={() => onChange(VEHICLE_TYPES_REDUCED.other)}
                    color="primary"
                    />
                }
                />
                </td>
            </tr>
            </tbody>
      </table>
      </FormControl>
    </div>
  )
}